module.exports = __webpack_public_path__ + "static/media/dina.643e1a12.svg";